import React from 'react';
import styled from 'astroturf/react';

import { Body } from 'js/design_system/Body';
import { Icon } from 'js/design_system/Icon';

const Option = styled.button<{ selected: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  border: 1px solid $ds-gray-light;
  border-radius: 8px;
  background: $ds-white;
  cursor: pointer;
  transition:
    border-color 150ms ease,
    box-shadow 150ms ease;

  &:hover {
    border-color: $ds-primary-blue;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  &.selected {
    border-color: $ds-primary-blue;
    background: $ds-secondary-blue;
  }
`;

const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex-shrink: 0;
  color: $ds-white;
`;

const ICON_BG_COLORS: Record<string, string> = {
  red: '#b60000',
  brown: '#a88260',
  yellow: '#c87a00',
  gray: '#535366',
};

const FA_TO_MATERIAL: Record<string, string> = {
  'fa-flag': 'flag',
  'fa-ban': 'block',
  'fa-question': 'help',
  'fa-user-slash': 'person_off',
};

interface FeedbackOptionProps {
  iconName: string;
  color: string;
  text: string;
  selected: boolean;
  onClick: () => void;
}

const FeedbackOption: React.FC<FeedbackOptionProps> = ({
  iconName,
  color,
  text,
  selected,
  onClick,
}) => {
  return (
    <Option type="button" selected={selected} onClick={onClick}>
      <IconCircle
        style={{ backgroundColor: ICON_BG_COLORS[color] ?? '#535366' }}
      >
        <Icon
          name={FA_TO_MATERIAL[iconName] ?? 'help'}
          size={18}
          style={{ color: 'inherit' }}
        />
      </IconCircle>
      <Body as="span" size="md" style={{ flex: 1, textAlign: 'left' }}>
        {text}
      </Body>
      {selected && <Icon name="check" size={20} style={{ color: '#0645b1' }} />}
    </Option>
  );
};

export default FeedbackOption;
